import { FC, useRef, useEffect, useCallback } from 'react'
import styles from '../../styles/admin/StudyContent.module.scss'

interface FractionQuestionInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  label?: string
}

const FractionQuestionInput: FC<FractionQuestionInputProps> = ({
  value,
  onChange,
  placeholder = '예: 3/4 + 1/2, 1  a/2 + ㅁ/12 = ?',
  className,
  label = '문제입력',
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const resize = useCallback(() => {
    const el = textareaRef.current
    if (!el) return
    el.style.height = 'auto'
    el.style.height = `${el.scrollHeight}px`
  }, [])

  // value가 외부에서 바뀔 때(편집 진입 시 기존 값 로드)도 높이 맞춤
  useEffect(() => {
    resize()
  }, [value, resize])

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value)
    resize()
  }

  return (
    <div className={styles.fractionQuestionContainer}>
      <div className={styles.questionInputWrapper}>
        <span className={styles.questionInputLabel}>{label}</span>
        <textarea
          ref={textareaRef}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          rows={1}
          className={`${styles.autoGrowTextarea} ${className ?? ''} symbol-input`}
        />
      </div>
    </div>
  )
}

export default FractionQuestionInput
